// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__1N0xH","linkLogo":"Logo_linkLogo__2BzP-","titleWrapper":"Logo_titleWrapper__1z-e3","title":"Logo_title__1eYhM"};